import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-morse-editor',
  templateUrl: './morse-editor.component.html',
  host: { '(window:keydown)': 'onKeyDown($event)', '(window:keyup)': 'onKeyUp($event)' },
  styleUrls: ['../topic-style.css', './morse-editor.component.css']
})
export class MorseEditorComponent{

  @Input('text')
  set text(value: string) {
    if(value){
    this.dText = value.split("");
    }
  }

  get text() {
    return this.dText.join("");
  }

  @Input() errors: number[] =[];

  @Output() selectedOut = new EventEmitter<number>();
  @Input() 
  set selectedIn(value: number){
    this.modus = "read";
    this.selected = this.text.split("|").slice(0, value).join("|").length+1;
    this.maxSelected = this.text.split("|").slice(0, value+1).join("|").length-1;
    if(value==0){
      this.selected = 0;
    }
  }

  dText: string[] = [];

  modus = "write";

  selected = 0;
  maxSelected = 0;
  
  get selectedOuterWorld(){
    return this.text.substring(0, this.selected).split("|").length - 1;
  }

  constructor() { }

  /** handles key press events and adjusts the text */
  onKeyDown(event) {
    
    if (!this.isFocused() || this.modus=="read") {
      return;
    }
    let backspace = 8;
    if (event.keyCode == backspace && this.selected > 0){
      this.selected--;
      
      while (this.dText[this.selected] === " " || this.dText[this.selected] === "|"  ) {
        this.selected -= 1;
      }
      this.dText[this.selected] = "#";
    }
    if (event.keyCode == 37 && this.selected > 0) {
      this.selected -= 1;
      
      while (this.dText[this.selected] === " " || this.dText[this.selected] === "|") {
        this.selected -= 1;
      }
    }

    if (event.keyCode == 39 && this.selected < this.dText.length - 1) {
      this.selected++;
      
      while (this.dText[this.selected] === " " || this.dText[this.selected] === "|") {
        this.selected++;
      }
    }
    if ((event.keyCode == 190 || event.keyCode == 189) && this.selected < this.dText.length) {
      this.dText[this.selected] = event.key;
      this.selected++;
      
      while (this.dText[this.selected] === " " || this.dText[this.selected] === "|") {
        this.selected++;
      }
    }
  }

  /** normalizes the text and emits the selected letter */
  onKeyUp() {
    if (!this.isFocused() ||  this.modus=="read") {
      return;
    }
    this.normalizeText();
    this.selectedOut.emit(this.selectedOuterWorld);

  }

  /** sets the focus and highlight on click */
  onClick(position: number) {
    if (!this.isFocused() || this.modus=="read") {
      return;
    }
    this.selected = position;
    
    while (this.dText[this.selected] == " " || this.dText[this.selected] === "|") {
      this.selected++;
    }
    this.selectedOut.emit(this.selectedOuterWorld);
  }

  /** normalizes the input */
  normalizeText() {
    this.text = this.dText.join("");
    this.text = this.text.toUpperCase().replace(/[^. #-|]/gi, "#");
    this.dText = this.text.split("");
  }

  /** returns the text */
  getText(): string {
    this.text = this.dText.join("");
    return this.text;
  }

  /** checks whether something else than the input field is focused */
  isFocused():boolean{
    if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
      return false;
    }
    return true;
  }

}
